export default __webpack_public_path__ + "static/media/latest-news-img28.20a96e20.jpg";